import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class TextLogo extends React.Component {
  render() {
    const { text, className } = this.props;
    const logoText = text ? text.slice(0, 2) : '';

    return (
      <div className={classNames(className, 'text-logo')}>
        <span>{logoText}</span>
      </div>
    );
  }
}

TextLogo.propTypes = {
  text: PropTypes.string,
};

export default TextLogo;
